<h1 class="mb-2 tp-hed text-center">Award Letter</h1>
<div class="awardletter">
  <ng-container *ngIf="awdletterSrc.documentTypeId == 'pdf'">
    <pdf-viewer
      [src]="getImgSrc(awdletterSrc?.uploadedFileId)"
      [render-text]="true"
      [original-size]="false"
      style="width: 100%; height: 100%"
    ></pdf-viewer>
  </ng-container>
  <!-- <ng-container
    *ngIf="
      awdletterSrc.documentTypeId == 'pdf' &&
      awdletterSrc?.uploadedFileId == null
    "
  >
    <ng-container *ngFor="let file of awdletterSrc?.analylizedFiles">
      <pdf-viewer
        [src]="getImgSrc(file)"
        [render-text]="true"
        [original-size]="false"
        style="width: 100%; height: 100%"
      ></pdf-viewer>
    </ng-container>
  </ng-container> -->
  <ng-container
    *ngIf="
      awdletterSrc.documentTypeId == 'png' ||
      awdletterSrc.documentTypeId == 'jpg' ||
      awdletterSrc.documentTypeId == 'jpeg'
    "
  >
    <img [src]="getImgSrc(awdletterSrc?.uploadedFileId)" style="width: 100%" />
  </ng-container>
  <ng-container
    *ngIf="
      awdletterSrc.documentTypeId == null &&
      awdletterSrc?.uploadedFileId == null
    "
  >
    <ng-container *ngFor="let file of awdletterSrc?.analylizedFiles">
      <img [src]="getImgSrc(file)" style="width: 100%" />
    </ng-container>
  </ng-container>
  <!-- <div *ngFor="let src of awdletterSrc"> -->

  <!-- </div> -->
</div>
<div class="text-center mt-2 pt-4 border-top">
  <button class="page-btn" (click)="close()">Close</button>
</div>
